import React from 'react';
import { Box } from '@chakra-ui/react';

import { BankFormPropTypes } from './bank.prop-types';

import type { BankFormProps } from './bank.types';

const BankForm = React.forwardRef((_props: BankFormProps, forwardRef: any) => (
  <div ref={forwardRef}>
    <Box></Box>
  </div>
));

BankForm.propTypes = BankFormPropTypes;

export { BankForm };
